import { render, staticRenderFns } from "./Postings.vue?vue&type=template&id=64ebed26"
import script from "./Postings.vue?vue&type=script&lang=ts"
export * from "./Postings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ebed26')) {
      api.createRecord('64ebed26', component.options)
    } else {
      api.reload('64ebed26', component.options)
    }
    module.hot.accept("./Postings.vue?vue&type=template&id=64ebed26", function () {
      api.rerender('64ebed26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jobboard/Postings.vue"
export default component.exports